import { Injectable, signal, inject } from "@angular/core";
import { WkDataTableStoreService } from "@components/data-table/store";
import type { WkDataTableStateColumn, WkDataTableStateColumns } from "@components/data-table/data-table.types";

@Injectable()
export class WkDataTableDraggingService {
    private readonly dataTableStore = inject(WkDataTableStoreService);

    public isDragging = signal<boolean>(false);

    public onColumnDropped(event: { previousIndex: number; currentIndex: number }) {
        const columns = [...this.dataTableStore.visibleColumns()];
        const [moved] = columns.splice(event.previousIndex, 1);
        columns.splice(event.currentIndex, 0, moved);

        const states: Record<string, WkDataTableStateColumn> = {};
        columns.forEach((col, index) => {
            const fieldName = col.fullFieldName();
            const column = this.dataTableStore.get(fieldName);
            states[fieldName] = {
                ...column?.state(),
                position: index,
            } as WkDataTableStateColumn;
        });

        this.dataTableStore.setStates(states as WkDataTableStateColumns);
    }

    public onColumnDragStarted() {
        this.isDragging.set(true);
    }

    public onColumnDragEnded() {
        this.isDragging.set(false);
    }
}
